import { render, staticRenderFns } from "./FarmPolygonEditDialog.vue?vue&type=template&id=31dc3b31&scoped=true"
import script from "./FarmPolygonEditDialog.vue?vue&type=script&lang=js"
export * from "./FarmPolygonEditDialog.vue?vue&type=script&lang=js"
import style0 from "./FarmPolygonEditDialog.vue?vue&type=style&index=0&id=31dc3b31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc3b31",
  null
  
)

export default component.exports